// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-checkout[data-v-41c37b93]{display:flex;justify-content:center;align-items:center;border-bottom:1px solid #eaeaea}.divider[data-v-41c37b93]{height:25px;width:1px;background-color:#fff}", ""]);
// Exports
module.exports = exports;
